import { IncentiveOfferEligibleApiItem } from 'modules/incentivesMarket/api/getIncentiveOfferEligibles';
import { Eligible } from 'modules/transactions/pages/TenderOfferDetails/types/Eligible';

const platformDomain = process.env.REACT_APP_DOMAIN;

export const mapIncentiveOfferEligiblesToTableRows = ({
  items,
  societyId,
}: {
  items: IncentiveOfferEligibleApiItem[];
  societyId: string;
}): Eligible[] =>
  (items || []).map((item) => ({
    name: item.name,
    email: item.email,
    totalUnits: item.totalUnits,
    link: item.planId
      ? `/detalle-beneficiario/${societyId}/${item.planId}/${item.id}`
      : '#',
    platformLink: `${platformDomain}/#/detalle-beneficiario/${societyId}/${item.planId}/${item.id}`,
    maximumSaleUnits: item.maximumSaleUnits,
    ndPercentage: item.ndPercentage,
    fdPercentage: item.fdPercentage,
    offerAmount: item.offerAmount,
    soldUnits: item.soldUnits,
    soldAmount: item.soldAmount,
    strikePrice: item.strikePrice,
    retentionPercentage: item.retentionPercentage,
    netAmount: item.netAmount,
    saleDate: item.saleDate ? new Date(item.saleDate) : null,
    statusLabel: item.statusLabel,
    statusBadge: item.statusBadge,
    isCanceled: item.isCanceled,
  }));
